<ng-template #cardTemplate let-meal="meal">
    <div class="card meal-card">
        <div class="card-body">
            <!--            <div-->
            <!--                    *ngIf="recipesByMeal[meal.id]?.length"-->
            <!--                    class="eaten-button-wrapper"-->
            <!--                    [class.eaten-button-disabled]="eatenMeals[meal.id]"-->
            <!--                    (click)="onMarkMealAsEaten(meal)"-->
            <!--            >-->
            <!--                <div class="responsive-flex-wrapper">-->
            <!--                    <i-->
            <!--                            [disableTooltip]="isActiveCheckDisable(meal, eatenMeals[meal.id])"-->
            <!--                            #activeCheck="ngbTooltip"-->
            <!--                            placement="top-right"-->
            <!--                            tooltipClass="tooltip-warning"-->
            <!--                            ngbTooltip="{{ 'check_after_consume' | localise }}"-->
            <!--                            class="fa fa-check"></i>-->
            <!--                </div>-->
            <!--            </div>-->
            <div class="eaten-backdrop" *ngIf="eatenMeals[meal.id]"></div>

            <p class="card-title text-md-center text-xl-left">{{ meal.title }}</p>

            <div class="recipes-list-wrapper">
                <div class="recipe-list-item"
                     *ngFor="let recipe of recipesByMeal[meal.id]">
                    <div (click)="onViewRecipe(recipe)"
                         class="font-weight-bold recipe-title">{{ recipe.recipe.title }}
                    </div>

                    <div
                            class="options"
                            *ngIf="isMasterProfile === true || (userProfile && userProfile.is_change_diary_disabled === false)"
                    >
                        <i class="icon-options-vertical"
                           [ngStyle]="{'color': (eatenMeals[meal.id] ? '#2c2d32' : '')}"
                           [app-popup]="{
                                  templateRef: productOptions,
                                  position: 'bottom',
                                  arrowPosition: ['top', 'right'],
                                  paddingless: true,
                                  closeUponSelection: true
                                }"></i>
                        <ng-template #productOptions>
                            <a class="dropdown-item preview-item" (click)="openCopyModal(recipe)">
                                <div class="preview-thumbnail">
                                    <div class="responsive-flex-wrapper">
                                        <i class="fa fa-clone text-primary"></i>
                                    </div>
                                </div>
                                <div class="preview-item-content">{{ 'meals_copy_btn' | localise }}</div>
                            </a>
                            <a class="dropdown-item preview-item" *ngIf="!isMealDisabledForEdit(meal.id)" (click)="onMarkMealAsEaten(meal)">
                                <div class="preview-thumbnail">
                                    <div class="responsive-flex-wrapper">
                                        <i class="fa fa-cutlery text-primary"></i>
                                    </div>
                                </div>
                                <div class="preview-item-content"
                                     *ngIf="!eatenMeals[meal.id]">{{ 'meals_mark_as_consume' | localise }}
                                </div>
                                <div class="preview-item-content" *ngIf="eatenMeals[meal.id]">
                                    {{ 'meals_mark_as_consumed' | localise }}
                                </div>
                            </a>
                            <a class="dropdown-item preview-item" *ngIf="!isMealDisabledForEdit(meal.id)" (click)="onRemoveRecipe(meal, recipe.recipe)">
                                <div class="preview-thumbnail">
                                    <div class="responsive-flex-wrapper">
                                        <i class="fa fa-times text-danger"></i>
                                    </div>
                                </div>
                                <div class="preview-item-content text-danger">{{ 'delete_title' | localise }}</div>
                            </a>
                        </ng-template>


                    </div>

                    <!--                    <div-->
                    <!--                            *ngIf="recipe.recipe.influencer"-->
                    <!--                            class="star-name">-->
                    <!--                        {{ 'dashboard_recipe_of' | localise }} <strong>{{ recipe.recipe.influencer.name }}</strong>-->
                    <!--                    </div>-->

                    <div
                            (click)="onViewRecipe(recipe)"
                            *ngIf="recipe.recipe.images && recipe.recipe.images.length > 0"
                            [ngStyle]="{'background': 'url(' + constants.imagesUrl() + '/images/850x500/' + recipe.recipe.images[0].type + '/' + recipe.recipe.images[0].name + '/) center center no-repeat'}"
                            class="recipe-image">

                        <div *ngIf="recipe.price > 0" class="diary-recipe-price">
                            {{ recipe.price }}
                            {{ 'currency' | localise }}
                        </div>

                        <!--                        <div class="star-image"-->
                        <!--                             *ngIf="recipe.recipe.influencer && recipe.recipe.influencer.images && recipe.recipe.influencer.images.length > 0"-->
                        <!--                             [lazyLoad]="constants.imagesUrl() + '/images/600x350/' + recipe.recipe.influencer.images[0].type + '/' + recipe.recipe.influencer.images[0].name + '/'"-->
                        <!--                        ></div>-->

                        <div class="recipe-calories">
                            <img [src]="getSvg('cal')"/>
                            <span>
                                {{ floor(recipe.macros.calories) }}
                                kcal
                            </span>
                        </div>
                    </div>

                    <div class="recipe-next-prev" *ngIf="isMasterProfile === true || (userProfile && userProfile.is_change_diary_disabled === false && !isMealDisabledForEdit(meal.id))">
                        <i (click)="loadPreviousRecipe(meal.id)" class="icon-control-rewind"></i>
                        <i (click)="loadNextRecipe(meal.id)" class="icon-control-forward"></i>
                    </div>

                    <!--                    <app-nutrients-breakdown [horizontal]="isMobileDevice()"-->
                    <!--                                             (click)="onViewRecipe(recipe)"-->
                    <!--                                             [calculations]="recipe.macros"></app-nutrients-breakdown>-->
                </div>
            </div>
            <div class="responsive-flex-wrapper"
                 *ngIf="caloriesLeftByMeal[meal.id] !== undefined && caloriesLeftByMeal[meal.id] > 20"
                 [style.margin-top]="recipesByMeal[meal.id] && recipesByMeal[meal.id].length <= 0 ? '50px' : ''"
                 [style.margin-bottom]="caloriesLeftByMeal[meal.id] !== undefined ? '32px' : ''">
                <button
                        type="button"
                        class="btn btn-inverse-primary btn-rounded btn-icon btn-with-tooltip"
                        (click)="openChooseCategoryModal(meal)">
                    <div class="responsive-flex-wrapper">
                        <i class="ti-plus"></i>
                    </div>
                    <div class="btn-tooltip-wrapper fadeInDown animated"
                         *ngIf="caloriesLeftByMeal[meal.id] !== undefined && caloriesLeftByMeal[meal.id] > 0">
                        {{ caloriesLeftByMeal[meal.id] }}&nbsp;<strong>kcal</strong>
                        <div class="btn-tooltip-arrow"></div>
                    </div>
                </button>
            </div>

            <ng-container *ngIf="externalRecipesByMeal[meal.id]">
                <p class="card-title cart-title-added-products text-md-center text-xl-left">
                    {{ 'added_meals' | localise }}
                </p>

                <ol class="external-meals-inline">
                    <ng-container *ngFor="let externalMeal of externalRecipesByMeal[meal.id]">
                        <li>
                            <div
                                    *ngIf="externalMeal.image_name && externalMeal.image_name.length > 0"
                                    [ngStyle]="{'background': 'url(' + constants.imagesUrl() + '/images/200x150/' + externalMeal.image_type + '/' + externalMeal.image_name + '/) center center no-repeat'}"
                                    class="external-meal-image"></div>


                            <div class="external-meal-inline-text">
                                {{ externalMeal.title }}

                                <strong>
                                    <ng-container
                                            *ngIf="externalMeal.by === 'WEIGHT'">{{ externalMeal.weight }} {{ 'abbreviation_gram' | localise }}
                                    </ng-container>
                                    <ng-container
                                            *ngIf="externalMeal.by === 'QTY'">{{ externalMeal.qty }} {{ 'br' | localise }}
                                    </ng-container>
                                </strong>

                                <br/>

                                <p>
                                    <ng-container *ngIf="externalMeal.calories > 0">
                                        ({{ externalMeal.calories }} kcal)
                                    </ng-container>
                                </p>
                            </div>

                            <div class="clear"></div>
                        </li>
                    </ng-container>
                </ol>
            </ng-container>

        </div>
    </div>
</ng-template>

<ng-template #datePickerTemplate>
    <div class="datepicker-wrapper">
        <button type="button" class="btn btn-icon" (click)="onDateBackwards()">
            <div class="responsive-flex-wrapper">
                <i class="ti-angle-left"></i>
            </div>
        </button>

        <div class="current-date">
            <app-datepicker #datepicker [date]="dateObj" (dateChanged)="onDatePickerChanged($event)"></app-datepicker>
        </div>

        <button type="button" class="btn btn-icon" (click)="onDateForwards()">
            <div class="responsive-flex-wrapper">
                <i class="ti-angle-right"></i>
            </div>
        </button>
    </div>
</ng-template>

<ng-container>
    <ng-container *ngIf="!isMasterProfile && isChatEnabled && !isUserMasterReady">
        <app-alerts-components
                [icon]="'ti-rocket'"
                [disableClose]="true"
                [id]="'profile_not_ready'"
                [title]="'Профилът ви не е готов.'"
                [message]="'Вашият профил все още не е готов за използване, защото се конфигурира от специалистите на Agaia. При въпроси не се колебайте да се свържете с нас.'"></app-alerts-components>
    </ng-container>

    <ng-container *ngIf="isMasterProfile || ((isChatEnabled && isUserMasterReady) || (!isChatEnabled && !isUserMasterReady))">
        <app-alerts-components
                [icon]="'ti-rocket'"
                [id]="'populate_training_section'"
                [title]="'enter_week_trainings' | localise"
                [btnLink]="'/settings/profile/training'"
                [btnTitle]="'profile_settings' | localise"
                [message]="'profile_settings_text' | localise"></app-alerts-components>

        <app-alerts-components
                *ngIf="showWarning() && getNextSuggestedDailyMeals() !== null"
                [type]="'warning'"
                [icon]="'fa fa-exclamation-triangle'"
                [id]="'warning_meal_calories_' + getNextSuggestedDailyMeals().id"
                [title]="'reduce_calories' | localise"
                [btnCallback]="warningCallback"
                [callbackParent]="this"
                [btnTitle]="('change_to' | localise) + ' ' + getNextSuggestedDailyMeals().title"
                [message]="'more_meals_text' | localise"></app-alerts-components>

        <app-alerts-components
                [icon]="'ti-help-alt'"
                [id]="'help_section'"
                [title]="'first_steps' | localise"
                [btnLink]="'/faq'"
                [btnTitle]="'faq' | localise"
                [message]="'faq_message' | localise"></app-alerts-components>

        <div *ngIf="motivationQuote.length > 0" id="motivation-quote" class="row">
            <div class="col-md-12 stretch-card grid-margin grid-margin-md-2">
                <div class="card data-icon-card-primary">
                    <div class="card-body">
                        <div class="row">
                            <div [ngClass]="'col-10'" class="text-white">
                                <i class="main-icon ti-f"></i>
                                <h3>{{ motivationQuote }}</h3>
                            </div>
                            <div (click)="hideQuote()" class="col-2 close-icon"><i class="ti-close"></i></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="desktop-only row justify-content-between form-group">
            <div class="col-sm-12 col-md-8" style="display: flex;">
                <button
                        *ngIf="hideAutoLoadRecipes === false && (isMasterProfile === true || (userProfile && userProfile.is_change_diary_disabled === false))"
                        type="button"
                        style="flex: 500px;"
                        class="btn btn-primary btn-icon-text random-meals-plan-btn d-sm-none d-none d-md-block"
                        (click)="onLoadRandomRecipes()">
                    <i class="ti-reload btn-icon-prepend"></i>
                    {{ 'load_recipes' | localise }}
                </button>
                <button type="button"
                        style="flex: 500px;"
                        [ngClass]="externalRecipes.length > 0 ? 'btn-primary' : 'btn-secondary'"
                        class="btn btn-icon-text random-meals-plan-btn d-sm-none d-none d-md-block"
                        (click)="openExternalMealsModal()">
                    <i class="fa-th-list fa btn-icon-prepend"></i>
                    {{ 'external_meals' | localise }}
                    <span *ngIf="externalRecipes.length > 0">({{ externalRecipes.length }})</span>
                </button>
                <button
                        type="button"
                        style="flex: 550px;"
                        class="btn btn-primary btn-icon-text random-meals-plan-btn d-sm-none d-none d-md-block"
                        (click)="openShoppingListModal()">
                    <i class="fa-shopping-bag fa btn-icon-prepend"></i>
                    {{ 'shopping_list' | localise }}
                </button>

                <i class="icon-options-vertical"
                   *ngIf="isMasterProfile === true || (userProfile && userProfile.is_change_diary_disabled === false)"
                   style="padding-top: 11px; font-size: 1.3rem; color: #3e404a; cursor: pointer;"
                   [app-popup]="{
                                  templateRef: actionMoreButtons,
                                  position: 'bottom',
                                  arrowPosition: ['top', 'right'],
                                  paddingless: true,
                                  closeUponSelection: true
                                }"></i>
                <ng-template #actionMoreButtons>
                    <a class="dropdown-item preview-item" (click)="openDiaryTrainingModal()">
                        <div class="preview-thumbnail">
                            <div class="responsive-flex-wrapper">
                                <i class="mdi mdi-dumbbell text-primary"></i>
                            </div>
                        </div>
                        <div class="preview-item-content">{{ 'diary_training' | localise }}</div>
                    </a>
                    <a class="dropdown-item preview-item" (click)="openDailyChangesActivitiesModal()">
                        <div class="preview-thumbnail">
                            <div class="responsive-flex-wrapper">
                                <i class="mdi mdi-weight text-primary"></i>
                            </div>
                        </div>
                        <div class="preview-item-content">
                            {{ 'dashboard_extra_load' | localise }}
                        </div>
                    </a>
                    <a class="dropdown-item preview-item" (click)="openCopyDiaryRecipesModal()">
                        <div class="preview-thumbnail">
                            <div class="responsive-flex-wrapper">
                                <i class="mdi mdi-content-copy text-primary"></i>
                            </div>
                        </div>
                        <div class="preview-item-content">
                            {{ 'copy_all_recipes' | localise }}
                        </div>
                    </a>
                    <a *ngIf="isMasterProfile === true" class="dropdown-item preview-item"
                       (click)="openCopyDiaryRecipesAdvancedModal()">
                        <div class="preview-thumbnail">
                            <div class="responsive-flex-wrapper">
                                <i class="mdi mdi-content-copy text-primary"></i>
                            </div>
                        </div>
                        <div class="preview-item-content">
                            {{ 'copy_all_recipes' | localise }} - Advanced
                        </div>
                    </a>
                    <a *ngIf="isMasterProfile === true" class="dropdown-item preview-item"
                       (click)="openCateringOrdersModal()">
                        <div class="preview-thumbnail">
                            <div class="responsive-flex-wrapper">
                                <i class="mdi mdi-content-copy text-primary"></i>
                            </div>
                        </div>
                        <div class="preview-item-content">
                            {{ 'create_order' | localise }}
                        </div>
                    </a>
                    <a class="dropdown-item preview-item" (click)="openDeleteDiaryRecipesModal()">
                        <div class="preview-thumbnail">
                            <div class="responsive-flex-wrapper">
                                <i class="mdi mdi-delete text-primary"></i>
                            </div>
                        </div>
                        <div class="preview-item-content">
                            {{ 'delete_recipes' | localise }}
                        </div>
                    </a>
                </ng-template>
            </div>
            <div class="col-sm-12 col-md-4 meals-datepicker-wrapper">
                <ng-template [ngTemplateOutlet]="datePickerTemplate"></ng-template>
            </div>
        </div>

        <div class="mobile-only row justify-content-between form-group">
            <div class="col-sm-12 col-md-12 meals-datepicker-wrapper">
                <ng-template [ngTemplateOutlet]="datePickerTemplate"></ng-template>
            </div>
        </div>

        <div class="row mobile-only" style="display: none">
            <div class="col-sm-12 col-md-12 mobile-actions">

                <app-swiper [class]="'mobile-actions'"
                            [config]="mobileActionsSwiperConfig">
                    <div>
                        <button
                                *ngIf="hideAutoLoadRecipes === false && (isMasterProfile === true || (userProfile && userProfile.is_change_diary_disabled === false))"
                                type="button"
                                class="btn"
                                (click)="onLoadRandomRecipes()">
                            <i class="ti-reload btn-icon-prepend"></i>
                            {{ 'load_recipes' | localise }}
                        </button>
                    </div>

                    <div>
                        <button type="button"
                                class="btn"
                                (click)="openExternalMealsModal()">
                            <i class="fa-th-list fa btn-icon-prepend"></i>
                            {{ 'external_meals' | localise }}
                        </button>
                    </div>

                    <div>
                        <button type="button"
                                class="btn"
                                (click)="openShoppingListModal()">
                            <i class="fa-shopping-bag fa btn-icon-prepend"></i>
                            {{ 'shopping_cart' | localise }}
                        </button>
                    </div>

                    <div>
                        <button type="button"
                                class="btn btn-mdi"
                                (click)="openDiaryTrainingModal()">
                            <i class="mdi mdi-dumbbell btn-icon-prepend"></i>
                            {{ 'diary_training' | localise }}
                        </button>
                    </div>

                    <div>
                        <button type="button"
                                class="btn btn-mdi"
                                (click)="openDailyChangesActivitiesModal()">
                            <i class="mdi mdi-weight btn-icon-prepend"></i>
                            {{ 'dashboard_extra_load' | localise }}
                        </button>
                    </div>
                </app-swiper>
            </div>
        </div>

        <div class="mobile-meals mobile-only row">
            <div class="col-12">
                <app-swiper [class]="'meals-swiper'"
                            [config]="mealsSwiperConfig">
                    <ng-container *ngFor="let meal of orderedUserDailyMeals">
                        <ng-template [ngTemplateOutlet]="cardTemplate"
                                     [ngTemplateOutletContext]="{ meal: meal }"></ng-template>
                    </ng-container>
                </app-swiper>
            </div>
        </div>

        <div class="desktop-meals desktop-only row">
            <div *ngFor="let meal of orderedUserDailyMeals" [class]="mealCardsClasses + ' grid-margin stretch-card'">
                <ng-template [ngTemplateOutlet]="cardTemplate" [ngTemplateOutletContext]="{ meal: meal }"></ng-template>
            </div>
        </div>

        <!--    <div class="row d-md-none">-->
        <!--        <div class="col-sm-12">-->
        <!--            <button type="button"-->
        <!--                    class="btn btn-primary btn-icon-text random-meals-plan-btn"-->
        <!--                    (click)="onLoadRandomRecipes()">-->
        <!--                <i class="ti-reload btn-icon-prepend"></i>-->
        <!--                {{ 'load_recipes' | localise }}-->
        <!--            </button>-->
        <!--            <button type="button"-->
        <!--                    class="btn btn-primary btn-icon-text random-meals-plan-btn"-->
        <!--                    [ngClass]="externalRecipes.length > 0 ? 'btn-primary' : 'btn-secondary'"-->
        <!--                    (click)="openExternalMealsModal()">-->
        <!--                <i class="fa-th-list fa btn-icon-prepend"></i>-->
        <!--                {{ 'external_meals' | localise }}-->
        <!--                <span *ngIf="externalRecipes.length > 0">({{ externalRecipes.length }})</span>-->
        <!--            </button>-->
        <!--            <button type="button"-->
        <!--                    class="btn btn-primary btn-icon-text random-meals-plan-btn"-->
        <!--                    (click)="openShoppingListModal()">-->
        <!--                <i class="fa-shopping-bag fa btn-icon-prepend"></i>-->
        <!--                {{ 'shopping_list' | localise }}-->
        <!--            </button>-->
        <!--        </div>-->
        <!--    </div>-->

        <div class="row">
            <div class="col-md-10">
                <app-macros-bar
                        [diaryMacros]="diaryMacros"
                        [userCalculations]="userCalculations"
                ></app-macros-bar>
            </div>

            <div class="col-md-2 water-macro-bar">
                <app-water-macro-bar-component *ngIf="date" [date]="date"></app-water-macro-bar-component>
            </div>
        </div>

        <div class="row" style="margin: 20px 0; position: relative; display: none !important;">
            <div class="water-blur-bg" *ngIf="isFreePlan">
                <button class="btn btn-primary" (click)="toPricing()">{{ 'unlock_micros' | localise }}</button>
            </div>

            <div
                    *ngFor="let productNutrients of productsNutrients; let i = index"
                    [ngClass]="'col-md-' + ((productsNutrients.length % 2 === 0 ? 12 / productsNutrients.length : 2))"
                    class="col-sm-4 col-4"
            >
                <circle-progress
                        [showInnerStroke]="false"
                        [titleFontSize]="'3rem'"
                        [unitsFontSize]="'1.5rem'"
                        [subtitleFontSize]="'1.8rem'"
                        [subtitle]="productNutrients.macro.title.toLocaleUpperCase()"
                        [percent]="diaryNutrientsByNutrientId[productNutrients.macro.id]
                                  ? calculatePercentage(+diaryNutrientsByNutrientId[productNutrients.macro.id].value, +productNutrients.reference_value)
                                  : 0"
                        [radius]="100"
                        [outerStrokeWidth]="16"
                        [outerStrokeColor]="'#78C000'"
                        [animation]="false"
                        [animationDuration]="0"
                ></circle-progress>
            </div>
        </div>

        <div class="row" *ngIf="isChatEnabled === true">
            <div id="chat" #chat>
                <div
                        *ngFor="let chatMessage of chatMessages; let i = index"
                        class="message"
                        [ngClass]="chatMessage.sender.id === userProfile.id ? 'second-user-message' : ''"
                >
                    <div class="message-container2">
                        <p class="author">
                            {{ chatMessage.sender.first_name }} {{ chatMessage.sender.last_name }}

                            <ng-container *ngIf="chatMessage.receiver.id != userProfile.id">
                            <span *ngIf="chatMessage.receiver_seen == false"><i title="Not Seen"
                                                                                class="not-seen fa fa-times-circle"></i></span>
                                <span *ngIf="chatMessage.receiver_seen == true"><i title="Seen"
                                                                                   class="seen fa fa-check-circle"></i></span>
                            </ng-container>
                        </p>
                        <div class="message-text" [innerHTML]="chatMessage.message | keepHtml"></div>
                        <p class="time">{{ formatCreatedTime(chatMessage.created_at) }}</p>
                    </div>

                    <div style="clear: both;"></div>
                </div>
            </div>

            <div id="chat-textarea">
            <textarea placeholder="{{ 'new_message' | localise }}" name="textarea" id="textarea-chat"
                      [(ngModel)]="chatMessage"></textarea>
                <button id="send" class="btn btn-sm btn-primary"
                        (click)="sendMessage()">{{ 'send_message' | localise }}
                </button>
            </div>
        </div>
    </ng-container>
</ng-container>
